import React from 'react';
import cx from 'classnames';
import s from './Loader.module.css';

export function Loader({ size, color, loaderWidth }) {
    return (
        <div className={s.loaderWrapper}>
            <div className={cx(s.spinner, s[loaderWidth])}>
                <div className={cx(s.spinner, s[size], s[color])} />
                <div className={cx(s.spinner, s[size], s[color])} />
                <div className={cx(s.spinner, s[size], s[color])} />
            </div>
        </div>
    );
}
